<template>
  <section>
    <footer class="main-footer">
      <div class="float-right hidden-xs">
        <b>Version</b> 2.0
      </div>
      <strong>Copyright &copy; {{new Date().getFullYear()}} <a href="#">{{appName}}</a>.</strong> All rights
      reserved.
    </footer>
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Tab panes -->
      <div class="tab-content">
        <div id="control-sidebar-theme-demo-options-tab" class="tab-pane active">
          <div>
            <h4 class="control-sidebar-heading">Opções de Layout</h4>
            <h4 class="control-sidebar-heading">Temas</h4>
            <ul class="list-unstyled clearfix">
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-blue")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span
                      style="display:block; width: 20%; float: left; height: 7px; background: #367fa9"></span><span
                      class="bg-light-blue" style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #222d32"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin">Azul</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-black")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div style="box-shadow: 0 0 2px rgba(0,0,0,0.1)" class="clearfix"><span
                      style="display:block; width: 20%; float: left; height: 7px; background: #fefefe"></span><span
                      style="display:block; width: 80%; float: left; height: 7px; background: #fefefe"></span></div>
                  <div><span style="display:block; width: 20%; float: left; height: 20px; background: #222"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin">Preto</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-purple")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-purple-active"></span><span class="bg-purple"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #222d32"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin">Roxo</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-green")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-green-active"></span><span class="bg-green"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #222d32"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin">Verde</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-red")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-red-active"></span><span class="bg-red"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #222d32"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin">Vermelho</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-yellow")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-yellow-active"></span><span class="bg-yellow"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #222d32"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin">Amarelo</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-blue-light")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span
                      style="display:block; width: 20%; float: left; height: 7px; background: #367fa9"></span><span
                      class="bg-light-blue" style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin" style="font-size: 12px">Azul Claro</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-black-light")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div style="box-shadow: 0 0 2px rgba(0,0,0,0.1)" class="clearfix"><span
                      style="display:block; width: 20%; float: left; height: 7px; background: #fefefe"></span><span
                      style="display:block; width: 80%; float: left; height: 7px; background: #fefefe"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin" style="font-size: 12px">Preto Claro</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-purple-light")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-purple-active"></span><span class="bg-purple"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin" style="font-size: 12px">Roxo Claro</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-green-light")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-green-active"></span><span class="bg-green"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin" style="font-size: 12px">Verde Claro</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-red-light")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-red-active"></span><span class="bg-red"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin" style="font-size: 12px">Vermelho Claro</p>
              </li>
              <li style="float:left; width: 33.33333%; padding: 5px;"><a role="button" title="Alterar Tema"
                  aria-label="Alterar Tema" @click='changeColor("skin-yellow-light")'
                  style="display: block; box-shadow: 0 0 3px rgba(0,0,0,0.4)" class="clearfix full-opacity-hover">
                  <div><span style="display:block; width: 20%; float: left; height: 7px;"
                      class="bg-yellow-active"></span><span class="bg-yellow"
                      style="display:block; width: 80%; float: left; height: 7px;"></span></div>
                  <div><span
                      style="display:block; width: 20%; float: left; height: 20px; background: #f9fafc"></span><span
                      style="display:block; width: 80%; float: left; height: 20px; background: #f4f5f7"></span></div>
                </a>
                <p class="text-center no-margin" style="font-size: 12px">Amarelo Claro</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </aside>
  </section>
</template>

<script>
  export default {
    methods: {
      changeColor(payload) {
        let mySkins = [
          'skin-blue',
          'skin-black',
          'skin-red',
          'skin-yellow',
          'skin-purple',
          'skin-green',
          'skin-blue-light',
          'skin-black-light',
          'skin-red-light',
          'skin-yellow-light',
          'skin-purple-light',
          'skin-green-light'
        ];
        $.each(mySkins, function (i) {
          $('body').removeClass(mySkins[i]);
        });
        $('body').addClass(payload);
        this.$store.commit('CHANGE_USER_SKIN', payload);
        this.getLayout();
      }
    }
  };
</script>

<style>
  aside::before {
    display: none !important;
  }
</style>